"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _icons = require("@wfp/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var iconLookup = {
  warning: {
    icon: _icons.iconWarning
  },
  error: {
    icon: _icons.iconWarningSolid
  },
  info: {
    icon: _icons.iconInfoSolid
  },
  success: {
    icon: _icons.iconCheckmark
  }
};

var Blockquote =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Blockquote, _React$Component);

  function Blockquote(props) {
    var _this;

    _classCallCheck(this, Blockquote);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Blockquote).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "toggleBlockquote", function () {
      _this.setState({
        open: !_this.state.open
      });
    });

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(Blockquote, [{
    key: "render",

    /*showInnerHtml = content => {
      return { __html: content };
    };*/
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          error = _this$props.error,
          style = _this$props.style,
          title = _this$props.title,
          toggleable = _this$props.toggleable,
          icon = _this$props.icon,
          light = _this$props.light,
          code = _this$props.code,
          warning = _this$props.warning,
          withIcon = _this$props.withIcon,
          info = _this$props.info,
          kind = _this$props.kind;
      var blockquoteClass = (0, _classnames.default)({
        'wfp--blockquote': true,
        'wfp--blockquote--toggleable': toggleable === true,
        'wfp--blockquote--light': light,
        'wfp--blockquote--code': code,
        'wfp--blockquote--no-content': !children,
        'wfp--blockquote--error': kind === 'error' || error,
        'wfp--blockquote--warning': kind === 'warning' || warning,
        'wfp--blockquote--success': kind === 'success',
        'wfp--blockquote--info': kind === 'info' || info,
        'wfp--blockquote--with-icon': withIcon || icon,
        'wfp--blockquote--open': this.state.open
      });
      var blockquoteContentClass = (0, _classnames.default)('wfp--blockquote__content', _defineProperty({}, "".concat(className), className)); // @deprecated Only kind is allowed

      var lookup = warning || kind === 'warning' ? iconLookup['warning'] : error || kind === 'error' ? iconLookup['error'] : kind === 'success' ? iconLookup['success'] : iconLookup['info'];
      var iconElement = _react.default.isValidElement(icon) ? _react.default.createElement("div", {
        className: "wfp--blockquote__icon wfp--blockquote__icon--custom"
      }, icon) : withIcon || icon ? _react.default.createElement(_Icon.default, {
        icon: icon ? icon : lookup.icon,
        description: "Blockquote Icon",
        className: "wfp--blockquote__icon",
        height: "30",
        width: "30"
      }) : null;
      return _react.default.createElement("div", {
        className: blockquoteClass
      }, iconElement, _react.default.createElement("div", {
        className: blockquoteContentClass,
        style: style
      }, title && _react.default.createElement("div", {
        onClick: this.toggleBlockquote,
        onKeyDown: this.toggleBlockquote,
        className: "wfp--blockquote__title",
        role: "button",
        tabIndex: 0
      }, title), children));
    }
  }]);

  return Blockquote;
}(_react.default.Component);

Blockquote.propTypes = {
  /**
   * Specify the content of your `Blockquote`
   */
  children: _propTypes.default.node,

  /**
   * Show content formated as code
   */
  code: _propTypes.default.bool,

  /**
   * Display content as `dangerouslySetInnerHTML` content
   */
  //innerHtml: PropTypes.string,

  /**
   * Display light version of Blockquote
   */
  light: _propTypes.default.bool,

  /**
   * Show options to show and hide the Blockquote
   */
  toogleable: _propTypes.default.bool,

  /**
   * Show title for Blockquote
   */
  title: _propTypes.default.node,

  /**
   * Specify the type of your Blockquote Options are `light` `code` `error` `warning` `info`
   */
  kind: _propTypes.default.string,

  /**
   * Specify if an Icon should be displayed
   */
  withIcon: _propTypes.default.bool,

  /**
   * Specify a custom icon. Can be either a `Icon` object or React component
   */
  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.object])
};
var _default = Blockquote;
exports.default = _default;